import { ThemeConfig } from 'antd'
import { FONT_FAMILY } from 'app/settings/defaultSetting'

const AntdTheme: ThemeConfig = {
  token: {
    colorPrimary: 'var(--color-primary)',
    controlItemBgActive: 'var(--color-antd-primary-bg)',
    colorPrimaryBg: 'var(--color-antd-primary-bg)',
    colorPrimaryHover: 'var(--color-antd-primary-bg)',
    fontFamily: `${FONT_FAMILY}, Arial, Helvetica, sans-serif`
  },
  components: {
    Table: {
      rowHoverBg: 'var(--color-antd-primary-bg)',
      rowSelectedHoverBg: 'var(--color-antd-primary-bg)',
      bodySortBg: 'transparent'
    },
    DatePicker: {
      colorPrimary: 'var(--color-primary)',
      hoverBorderColor: 'var(--color-primary)',
      colorBgContainerDisabled: 'transparent',
      colorTextDisabled: '#AAABAD',
      colorTextPlaceholder: '#AAABAD'
    },
    Checkbox: {
      colorPrimaryHover: 'var(--color-primary)'
    },
    Tabs: {
      itemHoverColor: 'var(--color-primary)',
      itemSelectedColor: 'var(--color-primary)',
      inkBarColor: 'var(--color-primary)'
    },
    Button: {
      colorPrimaryHover: 'var(--color-primary-3)'
    },
    Pagination: {
      colorPrimary: 'var(--color-primary)'
    },
    Slider: {
      colorPrimary: 'var(--color-primary)',
      colorPrimaryBorder: 'var(--color-primary)',
      colorPrimaryBorderHover: 'var(--color-primary)',
      handleColor: 'var(--color-primary)',
      dotActiveBorderColor: 'var(--color-primary)',
      handleActiveColor: 'var(--color-primary)',
      handleActiveOutlineColor: 'var(--color-primary)',
      trackHoverBg: 'var(--color-primary)',
      trackBg: 'var(--color-primary)'
    }
  }
}

export default AntdTheme
